import { variables } from 'config';
import getTheme from 'config/themes/base';

const theme = getTheme();

export default {
  root: {
    minHeight: `calc(100vh - ${variables.headerHeight} - ${variables.footerHeight} - 40px)`,
    width: '100%',
    borderRadius: 'unset',
    backgroundColor: theme.palette.primary.mainBackground,
    color: theme.palette.primary.main,
    flexGrow: 1,
    display: 'block',
    textAlign: 'start',
    padding: '24px',
    fontFamily: 'Montserrat, sans-serif',
    fontStyle: 'normal',
  },
  welcomeTitle: {
    fontSize: '24px',
    fontWeight: '700',
    color: '#1a1a1a',
    mb: 1,
    lineHeight: '1.2',
  },
  welcomeSubtitle: {
    fontSize: '16px',
    color: '#666666',
    mb: 3,
    lineHeight: '1.5',
  },
  sectionTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#1a1a1a',
    lineHeight: '1.3',
  },
  statCard: {
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
    height: '100%',
    transition: 'box-shadow 0.3s ease',
    '&:hover': {
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.12)',
    },
  },
  statLabel: {
    fontSize: '14px',
    fontWeight: '600',
    // color: '#666666',
  },
  statValue: {
    fontSize: '24px',
    fontWeight: '700',
    color: '#1a1a1a',
    mb: 0.5,
    lineHeight: '1.2',
  },
  statSubtitle: {
    fontSize: '14px',
    color: '#666666',
    mb: 0.5,
    lineHeight: '1.4',
  },
  statChange: {
    fontSize: '14px',
    fontWeight: '500',
  },
  statPlanText: {
    fontSize: '14px',
    color: '#666666',
    mt: 0.5,
    lineHeight: '1.4',
  },
  statUpgradeText: {
    fontSize: '14px',
    color: '#999999',
    lineHeight: '1.4',
  },
  statDescription: {
    fontSize: '14px',
    color: '#666666',
  },
  learnMoreLink: {
    fontSize: '14px',
    color: '#1976d2',
    textDecoration: 'none',
    fontWeight: '500',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  actionCard: {
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
    height: '100%',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&:hover': {
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.12)',
      transform: 'translateY(-2px)',
    },
  },
  actionCardSmall: {
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
    height: '100%',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&:hover': {
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.12)',
      transform: 'translateY(-2px)',
    },
  },
  actionTitle: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#1a1a1a',
  },
  actionTitleSmall: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#1a1a1a',
    lineHeight: '1.4',
  },
  actionDescription: {
    fontSize: '14px',
    color: '#666666',
    lineHeight: '1.5',
  },
  actionDescriptionSmall: {
    fontSize: '12px',
    color: '#666666',
    lineHeight: '1.5',
  },
  featureCard: {
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
    height: '100%',
    transition: 'box-shadow 0.3s ease',
    '&:hover': {
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.12)',
    },
  },
  featureTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#1a1a1a',
    lineHeight: '1.3',
  },
  featureDescription: {
    fontSize: '14px',
    color: '#666666',
    lineHeight: '1.5',
  },
  goToLink: {
    fontSize: '14px',
    color: '#1976d2',
    textDecoration: 'none',
    fontWeight: '500',
    display: 'inline-block',
    mt: 1,
    '&:hover': {
      textDecoration: 'underline',
    },
    '& .MuiIcon-root': {
      fontSize: '16px',
    },
  },
  progressText: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#666666',
  },
  gettingStartedCard: {
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
    height: '100%',
  },
  cardContentPadding: {
    padding: '12px !important',
  },
  gettingStartedTitle: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#1a1a1a',
    lineHeight: '1.4',
  },
  gettingStartedDescription: {
    fontSize: '14px',
    color: '#666666',
    lineHeight: '1.5',
  },
  viewAllLink: {
    width: 'fit-content',
    cursor: 'pointer',
    fontSize: '14px',
    color: '#6a7181',
    textDecoration: 'none',
    fontWeight: '500',
    '&:hover': {
      textDecoration: 'none',
    },
    '& .MuiIcon-root': {
      fontSize: '16px',
    },
  },
  videoCard: {
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
    height: '100%',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&:hover': {
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.12)',
      transform: 'translateY(-2px)',
    },
  },
  videoTitle: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#1a1a1a',
  },
  videoDescription: {
    fontSize: '14px',
    color: '#666666',
    lineHeight: '1.5',
  },
  videoDuration: {
    fontSize: '14px',
    color: '#999999',
    fontWeight: '500',
  },
  featureChip: {
    ml: 1.5,
    backgroundColor: 'white',
    border: '1px solid #666666',
    color: '#1a1a1a',
    fontSize: '11px',
    fontWeight: '500',
  },
  iconContainer: {
    width: 36,
    height: 36,
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiIcon-root': {
      fontSize: '20px',
    },
  },
  statIconBox: {
    width: 32,
    height: 32,
    borderRadius: '10px',
    backgroundColor: '#f1f0ee99',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiIcon-root': {
      fontSize: '18px',
    },
  },
  statIconBoxUpload: {
    width: 32,
    height: 32,
    borderRadius: '10px',
    backgroundColor: '#f5f5f5',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiIcon-root': {
      fontSize: '18px',
    },
  },
  progressBar: {
    mt: 1,
    mb: 1,
    height: 8,
    borderRadius: 4,
  },
  giftIcon: {
    color: '#29a36a',
    fontSize: 20,
  },
  freeImportChip: {
    backgroundColor: '#eaf6f0',
    color: '#29a36a',
    fontWeight: '500',
    fontSize: '12px',
    ml: 1,
    mb: 1.5,
    padding: '4px 6px',
  },
  newChip: {
    backgroundColor: '#f7eef0',
    color: '#812235',
    fontWeight: '500',
    fontSize: '12px',
    padding: '0px 4px',
  },
  quickActionIconContainer: {
    flexShrink: 0,
  },
  featureIconContainer: {
    width: 40,
    height: 40,
    '& .MuiIcon-root': {
      fontSize: '22px',
    },
    mb: 1.5,
  },
  freePlanCodeBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    backgroundColor: '#e2a3361a',
    padding: '6px 10px',
    border: '1px solid #e2a33633',
    borderRadius: '12px',
    '& .MuiIcon-root': {
      fontSize: '16px',
    },
  },
  freePlanCodeText: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#b87c14',
  },
  gettingStartedCardHover: {
    cursor: 'pointer',
    opacity: 1,
    '&:hover': {
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.12)',
      transform: 'translateY(-2px)',
    },
  },
  stepNumberBox: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    backgroundColor: '#f5f5f5',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    mr: 2,
    flexShrink: 0,
  },
  stepNumberText: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#666666',
  },
  stepIconContainer: {
    '.MuiIcon-root': {
      fontSize: '18px',
    },
  },
  stepIcon: {
    color: '#666666',
  },
  crownIcon: {
    color: '#c89a3d',
  },
  videoIconBox: {
    width: 36,
    height: 36,
    borderRadius: '12px',
    backgroundColor: '#f7eef0',
    border: '1px solid #e5e7eb',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    mr: 2,
    flexShrink: 0,
    '& .MuiIcon-root': {
      fontSize: '24px',
    },
  },
  videoChip: {
    backgroundColor: '#f7eef0',
    color: '#812235',
    fontWeight: '500',
    fontSize: '12px',
    padding: '0px 4px',
  },
  helpSectionBox: {
    backgroundColor: 'white',
    borderRadius: '8px',
    padding: '16px',
    mt: 2,
  },
  helpCard: {
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    height: '100%',
    '&:hover': {
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.12)',
      transform: 'translateY(-2px)',
    },
  },
  helpIconContainer: {
    width: 40,
    height: 40,
    '& .MuiIcon-root': {
      fontSize: '24px',
    },
  },
  helpIconContainerPink: {
    backgroundColor: '#f7eef0',
  },
  helpIconContainerGreen: {
    backgroundColor: '#eaf6f0',
  },
  helpIconContainerGold: {
    backgroundColor: '#f8f2e7',
  },
  helpArrowIcon: {
    fontSize: 20,
    color: '#9e9e9e',
  },
  dialogPaper: {
    borderRadius: '12px',
    padding: '8px',
  },
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    pb: 1,
  },
  dialogTitleIconBox: {
    width: 48,
    height: 48,
    borderRadius: '12px',
    backgroundColor: '#fff3e0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dialogTitleText: {
    fontSize: '20px',
    fontWeight: '600',
    color: '#1a1a1a',
  },
  dialogCloseButton: {
    color: '#666666',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
  dialogContentText: {
    fontSize: '16px',
    color: '#666666',
    lineHeight: '1.6',
    mb: 2,
  },
  dialogContentSubtext: {
    fontSize: '14px',
    color: '#999999',
    lineHeight: '1.5',
  },
  dialogActions: {
    padding: '16px 24px',
    gap: 1,
  },
  dialogButton: {
    backgroundColor: '#1976d2',
    color: 'white',
    textTransform: 'none',
    fontWeight: '600',
    borderRadius: '8px',
    padding: '8px 24px',
    '&:hover': {
      backgroundColor: '#1565c0',
    },
  },
  gettingStartedCardWrapper: {
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  videoCardWrapper: {
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  statsGridContainer: {
    mt: 3,
  },
  statIconColor: {
    color: '#6a7181b3',
  },
  progressBarUnlimited: {
    backgroundColor: '#e0e0e0',
    '& .MuiLinearProgress-bar': {
      backgroundColor: '#9e9e9e',
    },
  },
  progressBarFull: {
    '& .MuiLinearProgress-bar': {
      backgroundColor: '#d32f2f',
    },
  },
  progressBarNormal: {
    '& .MuiLinearProgress-bar': {
      backgroundColor: '#1976d2',
    },
  },
  uploadIconBox: {
    width: 32,
    height: 32,
    borderRadius: '10px',
    backgroundColor: '#f5f5f5',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiIcon-root': {
      fontSize: '18px',
    },
  },
  uploadIconColor: {
    color: '#666666',
  },
  giftIconColor: {
    color: '#29a36a',
    fontSize: 20,
  },
  quickActionsGridContainer: {
    mt: 4,
    alignItems: 'stretch',
  },
  quickActionsGrid: {
    display: 'flex',
    flexDirection: 'column',
  },
  quickActionsGridInner: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  quickActionCard: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  quickActionCardContent: {
    padding: '12px !important',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  quickActionBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    flex: 1,
  },
  iconContainerGreen: {
    backgroundColor: '#eaf6f0',
    flexShrink: 0,
  },
  iconContainerPink: {
    backgroundColor: '#f7eef0',
    flexShrink: 0,
  },
  iconContainerGray: {
    backgroundColor: '#f1f0ee',
    flexShrink: 0,
  },
  iconColorGreen: {
    color: '#29a36a',
  },
  iconColorPink: {
    color: '#812235',
  },
  iconColorGray: {
    color: '#6a7181',
  },
  iconColorGold: {
    color: '#b87c14',
  },
  arrowForwardIcon: {
    color: '#9e9e9e',
    fontSize: 20,
    flexShrink: 0,
  },
  featuresGrid: {
    flex: 1,
    display: 'flex',
  },
  featureCardFlex: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  featureCardContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
  },
  featureIconContainerLarge: {
    width: 40,
    height: 40,
    '& .MuiIcon-root': {
      fontSize: '22px',
    },
    mb: 1.5,
  },
  featureIconContainerPink: {
    backgroundColor: '#f7eef0',
  },
  featureIconContainerGold: {
    backgroundColor: '#f8f2e7',
  },
  featureLinkBox: {
    mt: 'auto',
    pt: 2,
  },
  gettingStartedGridContainer: {
    mt: 4,
    alignItems: 'stretch',
  },
  videoCardHover: {
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&:hover': {
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.12)',
      transform: 'translateY(-2px)',
    },
  },
  stepIconColor: {
    color: '#666666',
  },
  crownIconColor: {
    color: '#c89a3d',
  },
};
